<template>
  <apexchart type=bar
             v-bind:series="hour_of_day"
             v-bind:options="chart_options"
             width="99%" height=250 />
             
</template>

<script>
import 'array-flat-polyfill';
import util from '../../util'

export default {
  name: 'AccountDetailsHourOfDay',

  props : {
    txs: Array
  },

  computed : {
    hour_of_day : function(){
      var hod = [];
      for(var h = 0; h < 24; h += 1)
        hod.push(0);

      this.txs.flat().forEach(function(tx){
        var hour = new Date(util.ledger_time_to_unix(tx["tx"]["date"])).getHours();
        hod[hour] += 1;
      });

      return [{data:hod, name : 'Number of Txs'}];
    },

    chart_options : function(){
      return {'labels' : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
              dataLabels : {enabled : false}};
    }
  }
}
</script>

<style scoped>
</style>
